import { PaletteType } from '@/types/cinematics'
import { BrandingLayer } from '@/types/branding'
import { generateColorStyles } from '@/utils/generateColorShades'
import { buildTeamGradient } from './buildTeamGradient'

interface ResolveThemeStylesParams {
  ambiance: { palette: PaletteType }
  layer: BrandingLayer
}

/**
 * Single source of the CSS var string rendered by AppProvider's <style> tag.
 * Team branding only ever appends `--team-*` vars on top of the palette's
 * own vars — never replaces or removes an existing one. When `layer` isn't
 * `'team'`, the output is byte-for-byte what `generateColorStyles` alone
 * would produce today.
 */
export function resolveThemeStyles({ ambiance, layer }: ResolveThemeStylesParams): string {
  const baseStyles = generateColorStyles(ambiance?.palette || {})

  if (layer?.kind !== 'team') {
    return baseStyles
  }

  const baseColor = ambiance?.palette?.background?.['600'] ?? ''
  const gradient = buildTeamGradient({ baseColor, teamColor: layer.theme.color })

  return `${baseStyles}--team-color: ${layer.theme.color};\n--team-gradient: ${gradient};\n`
}
